
const Apiurl = 'https://managerorderreports.enjoytool.net/backend';
//const Apiurl = 'http://127.0.0.1:1706';
export default Apiurl
